import React from 'react';
import styled from 'styled-components';

const SectionWrapper = styled.section`

  
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center; /* 垂直置中 */
  justify-content: center;
  flex-wrap: nowrap; 
  padding:0% 0% 10% 0%;

  
  @media (max-width: 500px) {
    flex-direction: column;


  }


`;

const Subtitle = styled.h3`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.2em;
  color: #FFFF56;
  margin-bottom: 0px;
  padding:0px 0px 0px 5px;
  text-align: left;


  @media (max-width: 500px) {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 8px; /* 調整行間距 */
    padding: 0% 5% 0% 5%;
  }
`;

const Title = styled.h2`
  font-style: normal;
  font-weight: 700;
  font-size: 52px;
  line-height: 75px;
  letter-spacing: 0.05em;
  color: #FFFFFF;
  margin-top: 0px;
  margin-left: 0px;
  text-align: left;

  @media (max-width: 500px) {
    font-size: 32px;
    line-height: 10px;
    margin-bottom: 16px;
    margin-top:5%;
    padding: 0% 5% 5% 5%;

  }
`;


const DividerLine = styled.div`
  width: 1px;
  height: 50%;
  background-color: #FFFF56;
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(-50%, -50%);

  @media (max-width: 500px) {
    width: 90%;
    height: 1px;
    top: auto;
    bottom: 0;
    left: 5%;
    transform: translate(0, 0);

  }
`;

const TextWrapper = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 32px;
  color: #FFFFFF;
  align-items: center;
  padding: 2% 2% 2% 2%;
  margin-left: 0;


 
  @media (max-width: 500px) {
    max-width: 100%; 
    padding: 4% 5% 4% 5%;
    font-size: 14px;
    line-height: 24px;
  }


`;


const ReadMoreButton = styled.button`
  background-color:#000000;
  color:#FFFFFF;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.05em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 40px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  cursor: pointer;
  margin-top: 2%;

  @media (max-width: 500px) {
    font-size: 14px;
    line-height: 24px;
    
    padding: 6px 20px;

    margin: 0 auto 20% auto;

  }

  &:hover {
    background-color:#FFFFFF;
    color:#1f1f1f;
  }


`;

const BackgroundImage = styled.img`
  position: absolute;
  top: 50%;
  left: 25%;
  max-width: 100%;
  height: auto;
  object-fit: cover;
  display: block;

  @media (max-width: 500px) {
    display: none;
  }

  
`;

const BackgroundImage_mobile = styled.img`
  position: absolute;
  bottom: 0%;
  margin:0 auto;
  max-width: 100%;
  height: auto%;
  object-fit: cover;
  display: none;
  padding:0% 0% 10% 0%;


  @media (max-width: 500px) {
    display: block;

  }
  
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: left;
  padding: 2% 2% 2% 2%;

  @media (max-width: 500px) {
    padding: 0px; 
    width:100%;

  }

`;



const RetroPGF = () => (
  <SectionWrapper>
    <BackgroundImage src="/images/RetroPGF_Background.png" alt="DAO Background" />
    <BackgroundImage_mobile src="/images/RetroPGF_Background_mobile.png" alt="DAO Background" />
    
    <TitleContainer>
      <Subtitle>Retroactive Public Goods Funding</Subtitle>
      <Title>回溯性公共資助</Title>
      <DividerLine />
    </TitleContainer>
    <TextWrapper>
      <p>什麼是數位公共財？ 台灣建造數位公共財的參與者有誰，現況為何?<br/>回溯型公共資助是什麼？它是如何適用於台灣環境的？<br/>在開源社群中推廣回溯型公共資助方法，這對開源社群有什麼潛在益處？</p>
    </TextWrapper>
    <a href="/retropgf" style={{ textDecoration: 'none' }}><ReadMoreButton>閱讀更多</ReadMoreButton></a>
    
  </SectionWrapper>
);

export default RetroPGF;
